import React from "react";
import { SvgIcon, Box, BoxProps } from "@mui/material";

interface ArrowCircleProps extends BoxProps {
  size?: number; // width and height of the circle
  bgColor?: string; // background color
  shadow?: string; // box shadow
  arrowColor?: string; // color of the arrow
  direction?: "right" | "left"; // arrow direction
}

export const ArrowCircle: React.FC<ArrowCircleProps> = ({
  size = 32,
  bgColor = "#FFF",
  shadow = "0 1.455px 4.364px 0 rgba(37, 36, 39, 0.25)",
  arrowColor = "#212121",
  direction = "right",
  ...props
}) => {
  return (
    <Box
      display="flex"
      width={size}
      height={size}
      justifyContent="center"
      alignItems="center"
      borderRadius={size / 2}
      bgcolor={bgColor}
      boxShadow={shadow}
      {...props}>
      <SvgIcon
        sx={{
          width: 5,
          height: 8,
          transform: direction === "left" ? "rotate(180deg)" : "none",
        }}
        viewBox="0 0 5 8">
        <path
          d="M4.72768 3.99672C4.72768 4.08981 4.71314 4.1829 4.68405 4.26872C4.65291 4.35831 4.60109 4.43929 4.53277 4.50509L1.19677 7.81418C1.06659 7.9429 0.9015 8.00036 0.706591 8.00036C0.613799 8.00196 0.521684 7.9843 0.436062 7.9485C0.35044 7.9127 0.273171 7.85953 0.209136 7.79236C0.143528 7.72672 0.0918627 7.64849 0.0572439 7.56238C0.0226252 7.47627 0.00576695 7.38406 0.00768173 7.29127C0.00768173 7.08327 0.0731362 6.9189 0.209136 6.78945L3.02005 3.99672L0.188045 1.18945C0.125488 1.12361 0.0766761 1.04597 0.0444596 0.961059C0.0122431 0.876148 -0.00273198 0.785668 0.000409014 0.694904C0.000409014 0.501449 0.0731362 0.337086 0.209136 0.200359C0.275071 0.134215 0.353897 0.0823297 0.440723 0.0479248C0.527548 0.0135199 0.620519 -0.00267057 0.713864 0.000358549C0.915318 0.000358549 1.08841 0.0650858 1.21859 0.201086L4.53277 3.49563C4.6055 3.5669 4.65568 3.64618 4.68477 3.732C4.71386 3.81781 4.72768 3.90363 4.72768 4.00399V3.99672Z"
          fill={arrowColor}
        />
      </SvgIcon>
    </Box>
  );
};
